export class PreventGoBack {
    public static readonly type = '[Prevent back] set';
}

export class ResetPreventGoBack {
    public static readonly type = '[Prevent back] reset';
}
